import * as React from 'react';
import React__default, { useCallback, useMemo, useState, useEffect, Fragment } from 'react';
import { Heading, Checkbox, Tag, ButtonWithDropdown, Container } from '@grandvisionhq/elements';
import algoliaSearch from 'algoliasearch/lite';
import classnames from 'classnames';
import FocusTrap from 'focus-trap-react';
import { motion, AnimatePresence } from 'framer-motion';
import { connectSearchBox, connectStateResults, InstantSearch, Configure, Index, connectSortBy, connectRefinementList as connectRefinementList$1, connectRange as connectRange$1 } from 'react-instantsearch-dom';
export { InstantSearch } from 'react-instantsearch-dom';
import { IconButton, Util, MediaQuery, LockBodyScroll, Backdrop, SimpleRangeSlider, Button, Price, Expandable, RichTextArea, InfinitePagination } from '@grandvisionhq/common';
import { useIntl, useFeatureToggles, withIntl } from '@grandvisionhq/state';
import { Icon } from '@grandvisionhq/icons';
import { AlgoliaAnalyticsHelpers, AlgoliaAnalyticsTypes, ProductsSd, DataLayer } from '@grandvisionhq/analytics';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getNestedProperty, getFrontImage, getLocalizedValue, getAttrValue, useDebouncedEffect, LocaleUtils, withLazyLoading, replaceWhitespace } from '@grandvisionhq/utils';
import { Util as Util$1 } from '@grandvisionhq/stores-v2';
import { connectRefinementList, connectRange, connectCurrentRefinements, connectStats, Configure as Configure$1, connectStateResults as connectStateResults$1 } from 'react-instantsearch-core';
import ReactDOM from 'react-dom';
import orderBy from 'lodash/orderBy';
import useOnClickOutside from 'use-onclickoutside';
import uniqBy from 'lodash/uniqBy';
import { findResultsState } from 'react-instantsearch-dom/server';
import merge from 'lodash/merge';
import { decode } from 'querystring';
import flowRight from 'lodash/flowRight';
import packageInfo from 'search-insights/package.json';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';
import { ProductListing, Helpers, useProductDetailContext, createImpressionEvent, createInteractionEvent, ProductBannerView } from '@grandvisionhq/products';
import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';

function NoResults({ description ='' , title ='' , query =''  }) {
    return(/*#__PURE__*/ React.createElement("div", {
        className: "no-results"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        className: "no-results__title"
    }, title), /*#__PURE__*/ React.createElement("p", {
        className: "no-results__description"
    }, description.replace('{{searchQuery}}', `"${query}"`))));
}

const SearchBox = ({ currentRefinement , handleFocus , handleClose , handleSubmit , hasFocus , refine , forceFocus =false ,  })=>{
    const { getLabel  } = useIntl();
    const inputRef = React.useRef(null);
    React.useEffect(()=>{
        if (forceFocus) {
            if (inputRef.current) {
                inputRef.current.focus();
            }
            if (document.activeElement !== inputRef.current) {
                handleFocus();
            }
        }
    }, [
        forceFocus
    ]);
    const handleSearch = (event)=>{
        const value = event.currentTarget.value;
        if (refine) {
            refine(value);
        }
    };
    const onSubmit = ()=>{
        if (currentRefinement && currentRefinement.length >= 2) {
            handleSubmit(currentRefinement, 'products');
        }
    };
    const handleClearInput = ()=>{
        if (refine) {
            refine('');
        }
    };
    const handleKeyUp = (event)=>{
        if (event.key === 'Enter') {
            onSubmit();
        }
    };
    const handleBlur = (e)=>{
        const target = e === null || e === void 0 ? void 0 : e.relatedTarget;
        const excludedItemClicked = target && target instanceof HTMLElement && [
            'a',
            'button'
        ].includes(target.tagName.toLowerCase());
        if (!currentRefinement && !excludedItemClicked) {
            handleClose();
        }
    };
    const searchBoxClass = classnames('search-box', {
        'search-box--focus': hasFocus
    });
    const inputClass = classnames('search-box__input', {
        'search-box__input--focus': hasFocus
    });
    const searchIconClass = classnames('search-box-icons__search', {
        'search-box-icons__search--active': currentRefinement && currentRefinement.length > 0,
        'search-box-icons__search--focus': hasFocus
    });
    const clearInputClass = classnames('search-box-icons__clear', {
        'search-box-icons__clear--active': currentRefinement && currentRefinement.length > 0
    });
    return(/*#__PURE__*/ React.createElement("div", {
        className: searchBoxClass
    }, /*#__PURE__*/ React.createElement("input", {
        className: inputClass,
        type: "search",
        onBlur: handleBlur,
        onFocus: handleFocus,
        onSubmit: onSubmit,
        onChange: handleSearch,
        onKeyUp: handleKeyUp,
        placeholder: getLabel('search.searchField.placeholder'),
        value: currentRefinement,
        ref: inputRef,
        "data-t": "search-box"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "search-box-icons"
    }, /*#__PURE__*/ React.createElement("button", {
        "aria-label": getLabel('common.actions.search'),
        className: searchIconClass,
        onClick: onSubmit,
        type: "submit"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "search"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "search-box-icons__actions"
    }, /*#__PURE__*/ React.createElement("button", {
        className: clearInputClass,
        onClick: handleClearInput
    }, getLabel('search.searchField.clear')), /*#__PURE__*/ React.createElement(IconButton, {
        className: "search-box-icons__close",
        "aria-label": getLabel('common.actions.close'),
        onClick: handleClose
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "close"
    }))))));
};
var SearchBox$1 = connectSearchBox(SearchBox);

const ContentSuggestion = ({ suggestion , onClick ,  })=>{
    if (!suggestion.link || !suggestion.title || suggestion.link === '' || suggestion.title === '') {
        return null;
    }
    return(/*#__PURE__*/ React.createElement("a", {
        className: "content-suggestion__link",
        href: suggestion.link,
        onClick: ()=>onClick && onClick(suggestion.objectID, suggestion.position)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "content-suggestion__icon-wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "content",
        className: "content-suggestion__content-icon"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "content-suggestion--wrap-text"
    }, Util.truncateString(suggestion.title, 60))));
};

const ProductSuggestion = ({ productUrl , isContactLens , onClick , brand , name , imageUrl ,  })=>{
    return(/*#__PURE__*/ React.createElement("div", {
        className: "product-suggestion"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "product-suggestion__link",
        href: productUrl,
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-suggestion__image-holder"
    }, /*#__PURE__*/ React.createElement("img", {
        className: "product-suggestion__image",
        src: imageUrl,
        alt: brand
    })), /*#__PURE__*/ React.createElement("span", {
        className: "product-suggestion__name-holder"
    }, !isContactLens && /*#__PURE__*/ React.createElement("span", null, brand, " "), /*#__PURE__*/ React.createElement("span", {
        className: "product-suggestion__name"
    }, name)))));
};

function getProductImageUrl(suggestion, isBynderImagesEnabled = false, staticsUrl = '') {
    var ref;
    if (isBynderImagesEnabled) {
        const images = getNestedProperty(suggestion, 'masterVariant.media.images', []);
        const imageUrl = getFrontImage(images).url;
        return `${imageUrl}?w=75&auto=format`;
    }
    const images = getNestedProperty(suggestion, 'masterVariant.images', []);
    var ref1;
    const imageUrl = (ref1 = (ref = images[0]) === null || ref === void 0 ? void 0 : ref.url) !== null && ref1 !== void 0 ? ref1 : '';
    return imageUrl && `${staticsUrl}${imageUrl}?w=75&auto=format`;
}

function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
const ProductSuggestionContainer = ({ formatProductUrl , staticsUrl , suggestion , onClick ,  })=>{
    const { locale  } = useIntl();
    const { isBynderImagesEnabled  } = useFeatureToggles();
    const props = React.useMemo(()=>{
        const productType = getNestedProperty(suggestion, 'productType.obj.name');
        const isContactLens = CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType);
        var _name;
        const name = isContactLens ? getLocalizedValue(suggestion.name, locale) : (_name = suggestion.masterVariant.name) !== null && _name !== void 0 ? _name : '';
        const brand = String(getAttrValue(suggestion.masterVariant, 'brand')) || '';
        const sku = getNestedProperty(suggestion, 'masterVariant.sku');
        const slug = suggestion.slug;
        if (!brand || !name || !productType || !slug || !sku) {
            return null;
        }
        const productUrl = formatProductUrl({
            productType,
            sku,
            slug
        });
        const imageUrl = getProductImageUrl(suggestion, isBynderImagesEnabled, staticsUrl);
        return {
            isContactLens,
            name,
            brand,
            productUrl,
            imageUrl
        };
    }, [
        formatProductUrl,
        suggestion,
        staticsUrl,
        locale
    ]);
    const onSuggestionClick = React.useCallback(()=>{
        onClick && onClick(suggestion.objectID, suggestion.position);
    }, [
        suggestion,
        onClick
    ]);
    if (!props) {
        return null;
    }
    return(/*#__PURE__*/ React.createElement(ProductSuggestion, _extends$2({}, props, {
        onClick: onSuggestionClick
    })));
};

const SearchSuggestion = ({ suggestion , targetPath , onClick  })=>{
    return(/*#__PURE__*/ React.createElement("div", {
        className: "search-suggestion__item"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "search-suggestion__link",
        href: `${targetPath}${suggestion.query}`,
        onClick: ()=>onClick && onClick(suggestion.objectID, suggestion.position)
    }, suggestion.query)));
};

const StoreSuggestion = ({ suggestion , targetPath , isMultilingualEnabled , onClick ,  })=>{
    const { locale  } = useIntl();
    const getLocalizedValue = (storeField, fallBackValue)=>isMultilingualEnabled && storeField && storeField[locale] ? storeField[locale] : fallBackValue
    ;
    const selectedStore = getLocalizedValue(suggestion.storeNameLocalized, suggestion.storeName);
    const storeDetailsUrl = Util$1.getStoreDetailUrl(targetPath)(suggestion);
    return(/*#__PURE__*/ React.createElement("div", {
        className: "store-suggestion__item"
    }, /*#__PURE__*/ React.createElement("a", {
        "data-t": "SuggestionLink",
        className: "store-suggestion__link",
        href: storeDetailsUrl,
        onClick: ()=>onClick && onClick(suggestion.objectID, suggestion.position)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "store-suggestion__icon-wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "store",
        className: "store-suggestion__store-icon"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "store-suggestion__title store-suggestion--wrap-text"
    }, selectedStore), /*#__PURE__*/ React.createElement("span", {
        className: "store-suggestion__subtitle store-suggestion--wrap-text"
    }, `${getLocalizedValue(suggestion.townLocalized, suggestion.town)},  ${getLocalizedValue(suggestion.streetNameLocalized, suggestion.streetName)} ${suggestion.streetNumber || ''} `))));
};

function _defineProperty$7(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$7(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$7(target, key, source[key]);
        });
    }
    return target;
}
function SuggestionBlock({ title , noResults , showAll , handleSubmit , suggestions , render  }) {
    return(/*#__PURE__*/ React.createElement("div", {
        className: "suggestion-block"
    }, /*#__PURE__*/ React.createElement("span", {
        id: title,
        className: "suggestion-block__header"
    }, title), !suggestions || !Array.isArray(suggestions) || suggestions.length === 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "suggestion-block__no-results"
    }, noResults) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("ul", {
        className: "suggestion-block__results",
        "aria-label": title
    }, suggestions.map((suggestion, index)=>{
        if (suggestion) {
            const augmentedSuggestion = _objectSpread$7({}, suggestion, {
                position: index + 1
            });
            return(/*#__PURE__*/ React.createElement("li", {
                className: "suggestion-block__result",
                key: augmentedSuggestion.objectID
            }, render(augmentedSuggestion)));
        }
    })), handleSubmit && /*#__PURE__*/ React.createElement("button", {
        className: "suggestion-block__show-all",
        type: "button",
        "data-t": title,
        onClick: handleSubmit
    }, showAll))));
}

const getResultsByIndex = (searchResults, indexName)=>{
    if (!searchResults || !indexName) {
        return undefined;
    }
    if (Object.keys(searchResults).indexOf('hits') === -1) {
        return searchResults[indexName];
    } else if (searchResults && Object.keys(searchResults).indexOf('hits') !== -1) {
        return searchResults.index === indexName ? searchResults : undefined;
    }
};
const SearchResults = (props)=>{
    const { allSearchResults , formatProductUrl , pageRoutes , suggestionIndex , contentIndex , storeIndex , onSubmit , productIndex , searchState , staticsUrl , intl , isMultilingualEnabled ,  } = props;
    const { query: query1  } = searchState;
    const productSuggestions = getResultsByIndex(allSearchResults, productIndex.name);
    const querySuggestions = suggestionIndex && getResultsByIndex(allSearchResults, suggestionIndex.name);
    const storeSuggestions = storeIndex && getResultsByIndex(allSearchResults, storeIndex.name);
    const contentSuggestions = contentIndex && getResultsByIndex(allSearchResults, contentIndex.name);
    const isValidQuery = (query)=>{
        if (!!query && query.length >= 2) {
            return true;
        }
        return false;
    };
    const validQuery = isValidQuery(query1);
    const handleSubmit = ()=>{
        if (isValidQuery(query1)) {
            onSubmit(query1, 'products');
        }
    };
    const goToStores = ()=>{
        if (isValidQuery(query1)) {
            onSubmit(query1, 'stores');
        }
    };
    const handleClickAnalytics = React.useCallback((searchIndex)=>{
        return (objectID, position)=>{
            const currentSearchState = getResultsByIndex(allSearchResults, searchIndex);
            if (currentSearchState === null || currentSearchState === void 0 ? void 0 : currentSearchState.queryID) {
                AlgoliaAnalyticsHelpers.clickedObjectIdsAfterSearch({
                    searchIndex,
                    queryId: currentSearchState.queryID,
                    eventName: AlgoliaAnalyticsTypes.AlgoliaAnalyticsEvents.SearchSuggestionClicked,
                    objectIds: objectID,
                    positions: position
                });
            }
        };
    }, [
        allSearchResults
    ]);
    const showAllButtonClass = classnames('search-results__show-all-button', {
        'search-results__show-all-button--active': productSuggestions && validQuery && productSuggestions.nbHits > 0
    });
    const getStoresPath = ()=>{
        const pathFromPageRoutes = pageRoutes === null || pageRoutes === void 0 ? void 0 : pageRoutes.stores;
        const pathFromConfig = storeIndex && storeIndex.targetPath || '';
        return pathFromPageRoutes || pathFromConfig;
    };
    return(/*#__PURE__*/ React.createElement("div", {
        className: "search-results"
    }, querySuggestions && /*#__PURE__*/ React.createElement("div", {
        className: "search-results__suggestions search-results__query-suggestions"
    }, /*#__PURE__*/ React.createElement(SuggestionBlock, {
        suggestions: querySuggestions.hits,
        title: intl.getLabel('search.suggestions.suggestions.title'),
        showAll: intl.getLabel('search.showAll'),
        noResults: intl.getLabel('search.noResults.title'),
        render: (hit)=>/*#__PURE__*/ React.createElement(SearchSuggestion, {
                key: hit.objectID,
                suggestion: hit,
                targetPath: suggestionIndex && suggestionIndex.targetPath || '',
                onClick: handleClickAnalytics(querySuggestions.index)
            })
    })), /*#__PURE__*/ React.createElement("div", {
        className: "search-results__suggestions"
    }, productSuggestions && validQuery && /*#__PURE__*/ React.createElement(SuggestionBlock, {
        title: intl.getLabel('search.suggestions.products.title'),
        showAll: intl.getLabel('search.showAll'),
        noResults: intl.getLabel('search.noResults.title'),
        handleSubmit: handleSubmit,
        suggestions: productSuggestions.hits,
        render: (hit)=>/*#__PURE__*/ React.createElement(ProductSuggestionContainer, {
                key: hit.objectID,
                formatProductUrl: formatProductUrl,
                staticsUrl: staticsUrl,
                suggestion: hit,
                onClick: handleClickAnalytics(productSuggestions.index)
            })
    })), /*#__PURE__*/ React.createElement("div", {
        className: "search-results__suggestions"
    }, storeSuggestions && validQuery && /*#__PURE__*/ React.createElement(SuggestionBlock, {
        title: intl.getLabel('search.suggestions.stores.title'),
        showAll: intl.getLabel('search.showAll'),
        noResults: intl.getLabel('search.noResults.title'),
        handleSubmit: goToStores,
        suggestions: storeSuggestions.hits,
        render: (hit)=>/*#__PURE__*/ React.createElement(StoreSuggestion, {
                isMultilingualEnabled: isMultilingualEnabled,
                key: hit.objectID,
                suggestion: hit,
                targetPath: getStoresPath(),
                onClick: handleClickAnalytics(storeSuggestions.index)
            })
    })), /*#__PURE__*/ React.createElement("div", {
        className: "search-results__suggestions"
    }, contentSuggestions && validQuery && /*#__PURE__*/ React.createElement(SuggestionBlock, {
        title: intl.getLabel('search.suggestions.content.title'),
        noResults: intl.getLabel('search.noResults.title'),
        suggestions: contentSuggestions.hits,
        render: (hit)=>/*#__PURE__*/ React.createElement(ContentSuggestion, {
                key: hit.objectID,
                suggestion: hit,
                onClick: handleClickAnalytics(contentSuggestions.index)
            })
    })), productSuggestions && validQuery && /*#__PURE__*/ React.createElement("div", {
        className: "search-results__show-all"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: handleSubmit,
        className: showAllButtonClass
    }, intl.getLabel('search.showAll')))));
};
var SearchResults$1 = connectStateResults(withIntl(SearchResults));

const posedContent = {
    idle: {
        height: 0,
        overflow: 'hidden'
    },
    focusFixed: {
        height: 'auto',
        transition: {
            delay: 0.15,
            ease: 'easeIn'
        },
        transitionEnd: {
            overflow: 'auto'
        }
    },
    focusStatic: {
        height: 'auto',
        transition: {
            ease: 'easeInOut'
        },
        transitionEnd: {
            overflow: 'auto'
        }
    }
};
const posedSearchBar = {
    idle: {
        position: 'relative',
        top: 0,
        left: 0,
        right: 0,
        height: '100%',
        transition: {
            duration: 0
        }
    },
    focusFixed: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 74,
        transition: {
            type: 'tween',
            ease: 'circOut',
            duration: 0.25
        }
    },
    focusStatic: {
        height: 74
    }
};
const SearchBar = ({ pageRoutes , isMultilingualEnabled , formatProductUrl , staticsUrl , onSubmit , onClose , onFocus , forceFocus , config , isMobile ,  })=>{
    const intl = useIntl();
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const searchClient = algoliaSearch(config.appId, config.apiKey);
    const [hasFocus, setHasFocus] = React.useState(false);
    const [pose, setPose] = React.useState();
    const { productIndex , indexes =[]  } = config;
    let resultConfig = {};
    if (indexes && Array.isArray(indexes)) {
        resultConfig = indexes.reduce((prev, curr)=>{
            switch(curr.type){
                case 'suggestions':
                    prev.suggestionIndex = curr;
                    break;
                case 'stores':
                    prev.storeIndex = curr;
                    break;
                case 'content':
                    prev.contentIndex = curr;
                    break;
            }
            return prev;
        }, {});
    }
    const isWideScreen = ()=>currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE || currentBreakpoint === MediaQuery.BreakpointName.DESKTOP
    ;
    const configureIndexes = (index)=>{
        const localeFilter = `locale:${intl.locale.replace('-', '_')}`;
        const filtersWithLocaleCheck = index.filters ? `${localeFilter} AND (${index.filters})` : localeFilter;
        const filters = isMultilingualEnabled && index.type === 'content' ? filtersWithLocaleCheck : index.filters;
        return(/*#__PURE__*/ React.createElement(Index, {
            indexName: index.name,
            key: index.name
        }, /*#__PURE__*/ React.createElement(Configure, {
            filters: filters,
            analytics: true
        })));
    };
    const handleFocus = React.useCallback(()=>{
        setHasFocus(true);
        onFocus && onFocus();
        Util.lockScroll();
    }, [
        onFocus
    ]);
    const handleClose = React.useCallback(()=>{
        setHasFocus(false);
        onClose && onClose();
        Util.unlockScroll();
    }, [
        onClose
    ]);
    const configuredIndexes = React.useMemo(()=>indexes.map(configureIndexes)
    , [
        indexes
    ]);
    React.useEffect(()=>{
        // Close search bar upon pressing esc
        const closeSearchBar = (event)=>{
            if (event.key === 'Escape') {
                handleClose();
            }
        };
        document.addEventListener('keydown', closeSearchBar, false);
        return ()=>{
            document.removeEventListener('keydown', closeSearchBar, false);
        };
    }, []);
    React.useEffect(()=>{
        const EMPTY = '';
        const IDLE = 'idle';
        const FOCUS_FIXED = 'focusFixed';
        const FOCUS_STATIC = 'focusStatic';
        setPose([
            IDLE,
            hasFocus && isWideScreen() ? FOCUS_FIXED : EMPTY,
            hasFocus && !isWideScreen() ? FOCUS_STATIC : EMPTY, 
        ].filter(Boolean));
    }, [
        hasFocus,
        currentBreakpoint
    ]);
    const handleKeyUp = (event)=>{
        if (event.key === 'Enter') {
            handleFocus();
        }
    };
    const renderSearch = ()=>/*#__PURE__*/ React.createElement(FocusTrap, {
            active: hasFocus
        }, /*#__PURE__*/ React.createElement(InstantSearch, {
            searchClient: searchClient,
            indexName: productIndex.name
        }, hasFocus && /*#__PURE__*/ React.createElement(LockBodyScroll, null), /*#__PURE__*/ React.createElement(motion.div, {
            role: "dialog",
            "aria-modal": true,
            "aria-label": intl.getLabel('common.actions.search'),
            animate: pose,
            className: classnames('search-bar', {
                'search-bar--focus': hasFocus
            })
        }, /*#__PURE__*/ React.createElement(Configure, {
            hitsPerPage: 4,
            clickAnalytics: true,
            filters: productIndex.filters
        }), configuredIndexes, /*#__PURE__*/ React.createElement(motion.div, {
            className: "search-bar__pose-container",
            variants: posedSearchBar,
            initial: "idle",
            animate: pose
        }, /*#__PURE__*/ React.createElement("div", {
            className: "search-bar__container"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "search-bar__box-container"
        }, /*#__PURE__*/ React.createElement(SearchBox$1, {
            hasFocus: hasFocus,
            handleFocus: handleFocus,
            handleClose: handleClose,
            handleSubmit: onSubmit,
            forceFocus: !!forceFocus
        })))), /*#__PURE__*/ React.createElement(motion.div, {
            variants: posedContent,
            initial: "idle",
            animate: pose,
            className: "search-bar__content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "search-bar__content-container"
        }, hasFocus && /*#__PURE__*/ React.createElement(SearchResults$1, {
            isMultilingualEnabled: isMultilingualEnabled,
            formatProductUrl: formatProductUrl,
            pageRoutes: pageRoutes,
            productIndex: productIndex,
            staticsUrl: staticsUrl,
            storeIndex: resultConfig.storeIndex,
            suggestionIndex: resultConfig.suggestionIndex,
            contentIndex: resultConfig.contentIndex,
            onSubmit: onSubmit
        })), /*#__PURE__*/ React.createElement("div", {
            className: "search-bar__content-scroll-indicator"
        })), /*#__PURE__*/ React.createElement(Backdrop, {
            className: "search-bar__backdrop",
            onClick: handleClose,
            isVisible: hasFocus,
            poseConfig: {
                exit: {
                    opacity: 0
                },
                enter: {
                    opacity: 1,
                    transition: {
                        delay: 0.25
                    }
                }
            }
        }))))
    ;
    return(/*#__PURE__*/ React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/ React.createElement("input", {
        className: "search-bar__input",
        onClick: handleFocus,
        onKeyDown: handleKeyUp,
        onInput: handleFocus,
        placeholder: intl.getLabel('search.searchField.placeholder'),
        "data-t": "search-bar",
        "aria-label": intl.getLabel('common.actions.search'),
        // We handle this in the opened search bar
        value: ""
    }), hasFocus || forceFocus ? renderSearch() : null));
};
var SearchBar$1 = /*#__PURE__*/ React.memo(SearchBar);

var FacetId;
(function(FacetId) {
    FacetId[// we will only list FacetId's which have a special meaning and are used in our code
    // facets to render when no productType is selected (primary facets):
    "productType"] = "productType";
    FacetId["price"] = "price";
    FacetId["brand"] = "brand";
    FacetId[// facets which represent colors
    "lensColor"] = "lensColor";
    FacetId["frameColor"] = "frameColor";
    FacetId[// id to recognize the commercetools category-facet
    "categoryExternalId"] = "categoryExternalId";
})(FacetId || (FacetId = {}));
const PrimaryFacets = {
    [FacetId.productType]: true,
    [FacetId.price]: true,
    [FacetId.brand]: true
};
function isFacetHidden(facet) {
    return facet.hidden === true;
}
function isFacetVisible(facet) {
    return !isFacetHidden(facet);
}
function isValidAlgoliaSearchConfig(obj) {
    return Object.values(obj).every(Boolean);
}

const DEFAULT_ALGOLIA_CONFIG = {
    isEnabled: false,
    algoliaInstantSearchProps: {
        indexName: '',
        searchState: {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSearchStateChange: ()=>{},
        searchClient: {}
    },
    facets: [],
    pageSize: 24,
    sortIndices: [],
    presetQueryObject: {},
    ruleContexts: []
};
const AlgoliaConfig = /*#__PURE__*/ React.createContext(DEFAULT_ALGOLIA_CONFIG);
const useAlgoliaConfig = ()=>React.useContext(AlgoliaConfig)
;

function useItemsToClear(items) {
    const { facets  } = useAlgoliaConfig();
    const visibleFacets = facets.filter(isFacetVisible);
    return items.filter((item)=>visibleFacets.find(({ attribute  })=>attribute === item.attribute
        )
    );
}

const ClearFacetFilter = ({ onClear , isDisabled =false , label  })=>/*#__PURE__*/ React.createElement("button", {
        className: "clear-facet-filter",
        onClick: onClear,
        disabled: isDisabled,
        type: "button"
    }, label)
;

const orderFacetOptions = ({ facet , items  })=>facet.orderBy ? orderBy(items, facet.orderBy.map((x)=>x.attribute
    ), facet.orderBy.map((x)=>x.direction
    )) : items
;

function getFacetOptionLabel(facet, itemLabel, intl) {
    const options = facet.options && facet.options[itemLabel.toLowerCase()];
    const labelFromOptions = options && (options.labelKey ? intl.getLabel(options.labelKey) : options.label);
    return {
        icon: options && options.icon,
        label: labelFromOptions || itemLabel
    };
}

const RefinementItem = ({ item , facet , onRefine  })=>{
    const handleChange = React.useCallback(()=>onRefine(item.value)
    , [
        item
    ]);
    const intl = useIntl();
    const { icon , label  } = React.useMemo(()=>getFacetOptionLabel(facet, item.label, intl)
    , [
        facet,
        item, 
    ]);
    return(/*#__PURE__*/ React.createElement("label", {
        className: "refinement-item"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "refinement-item__checkbox"
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        checked: item.isRefined,
        value: item.label,
        onChange: handleChange,
        "aria-label": label
    })), /*#__PURE__*/ React.createElement("span", {
        className: "refinement-item__value"
    }, icon && /*#__PURE__*/ React.createElement(Icon, {
        name: icon
    }), " ", label), /*#__PURE__*/ React.createElement("span", {
        className: "refinement-item__count"
    }, item.count)));
};

const FacetSearchBox = ({ placeholder , onSearch  })=>/*#__PURE__*/ React.createElement("div", {
        className: "facet-searchbox"
    }, /*#__PURE__*/ React.createElement("input", {
        className: "facet-searchbox__input",
        type: "search",
        onChange: onSearch,
        placeholder: placeholder,
        "aria-label": "Search through filter options"
    }), /*#__PURE__*/ React.createElement(Icon, {
        name: "search",
        className: "facet-searchbox__icon"
    }))
;

const FacetHeaderMobile = ({ refineCount , onSearch , onClear , intl , title , isExpanded ,  })=>{
    const titleClass = classnames('facet-header-mobile__title', {
        'facet-header-mobile__title--expanded': isExpanded
    });
    return(/*#__PURE__*/ React.createElement("div", {
        className: "facet-header-mobile"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "facet-header-mobile__heading"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: titleClass
    }, title), isExpanded && onClear && /*#__PURE__*/ React.createElement(ClearFacetFilter, {
        onClear: onClear,
        isDisabled: refineCount === 0,
        label: intl.getLabel('search.filters.clear', {
            defaultValue: 'clear'
        })
    })), isExpanded && /*#__PURE__*/ React.createElement("span", {
        className: "facet-header-mobile__divider"
    }), isExpanded && onSearch && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "facet-header-mobile__search"
    }, /*#__PURE__*/ React.createElement(FacetSearchBox, {
        placeholder: intl.getLabel('search.filters.placeholder'),
        onSearch: (event)=>onSearch(event.target.value)
    })))));
};
var FacetHeaderMobile$1 = withIntl(FacetHeaderMobile);

const FacetContainerMobile = ({ children , onClear , onSearch , onShowMore , refineCount , labels , isActive , itemCount ,  })=>{
    const [isExpanded, setExpanded] = React.useState(false);
    const handleShowMore = ()=>{
        onShowMore && onShowMore();
    };
    return(/*#__PURE__*/ React.createElement("div", {
        className: "facet-container-mobile"
    }, /*#__PURE__*/ React.createElement(FacetHeaderMobile$1, {
        title: labels.title,
        refineCount: refineCount,
        onSearch: onSearch,
        onClear: onClear,
        isExpanded: !!isActive
    }), /*#__PURE__*/ React.createElement("div", {
        className: "facet-container-mobile__inner"
    }, isExpanded || isActive ? children : React.Children.toArray(children).slice(0, 6)), (itemCount > 6 || isExpanded) && !isActive && /*#__PURE__*/ React.createElement("div", {
        className: "facet-container-mobile__footer"
    }, itemCount > 15 && !isExpanded && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: handleShowMore,
        className: "facet-container-mobile__footer-button"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "search",
        className: "facet-container-mobile__footer-icon"
    }), labels.showMore), itemCount <= 15 && /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: ()=>setExpanded(!isExpanded)
        ,
        className: "facet-container-mobile__footer-button"
    }, isExpanded ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-up",
        className: "facet-container-mobile__footer-icon"
    }), labels.showLess) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down",
        className: "facet-container-mobile__footer-icon"
    }), labels.showMore)))));
};

const ConnectedFacetContainerMobile = ({ facet , attribute , items , refine , title , isActive , onToggle , searchable , searchForItems , isFromSearch , expandedState , showMoreLabel , showLessLabel ,  })=>{
    const handleShowMore = useCallback(()=>{
        onToggle(attribute);
    }, [
        attribute
    ]);
    const labels = useMemo(()=>({
            title,
            showMore: showMoreLabel,
            showLess: showLessLabel
        })
    , [
        title,
        showMoreLabel,
        showLessLabel
    ]);
    if (!items.length && !isFromSearch) {
        return null;
    }
    const facetListClass = classnames('connected-facet-container-mobile', {
        'connected-facet-container-mobile--hidden': expandedState && !isActive
    });
    const sortedItems = orderFacetOptions({
        facet,
        items
    });
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: facetListClass
    }, /*#__PURE__*/ React__default.createElement(FacetContainerMobile, {
        onSearch: searchable ? searchForItems : undefined,
        refineCount: items.filter((x)=>x.isRefined
        ).length,
        onClear: handleClear,
        labels: labels,
        onShowMore: handleShowMore,
        isActive: isActive,
        itemCount: items.length
    }, sortedItems.map((item)=>/*#__PURE__*/ React__default.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: refine
        })
    ))));
    function handleClear() {
        refine([]);
    }
};
var ConnectedFacetContainerMobile$1 = connectRefinementList(ConnectedFacetContainerMobile);

const FacetInputPriceRange = ({ min , max , value , onChange , renderNumber =(v)=>v
  })=>{
    const { range , setRange , dispatchRange  } = useFacetInputPriceRangeValue(value, onChange);
    const { currency , getLabel  } = useIntl();
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: "facet-input-price-range"
    }, /*#__PURE__*/ React__default.createElement(SimpleRangeSlider, {
        value: [
            range.min,
            range.max
        ],
        min: min,
        max: max,
        currency: currency,
        onChange: ([newMin, newMax])=>setRange({
                min: newMin,
                max: newMax
            })
        ,
        onAfterChange: dispatchRange,
        renderNumber: renderNumber,
        ariaLabel: getLabel('search.filters.pricerange.select', {
            defaultValue: 'Select a price range'
        })
    })));
};
function useFacetInputPriceRangeValue(value, onChange) {
    const [range, setRange] = useState(value);
    const dispatchRange = useCallback(()=>onChange(range)
    , [
        range.min,
        range.max
    ]);
    useEffect(()=>setRange(value)
    , [
        value.min,
        value.max
    ]);
    return {
        range,
        setRange,
        dispatchRange
    };
}

const ConnectedFacetInputPriceRangeMobile = ({ refine , title , min , max , showLessLabel , showMoreLabel , currentRefinement , expandedState , isActive ,  })=>{
    const clearHandler = useCallback(()=>refine({
            min,
            max
        })
    , [
        min,
        max
    ]);
    const labels = useMemo(()=>({
            title,
            showMore: showMoreLabel,
            showLess: showLessLabel
        })
    , [
        title,
        showMoreLabel,
        showLessLabel
    ]);
    if (min === max) {
        return null;
    }
    const facetListClass = classnames('facet-input-price-range-mobile', {
        'facet-input-price-range-mobile--hidden': expandedState && !isActive
    });
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: facetListClass
    }, /*#__PURE__*/ React__default.createElement(FacetContainerMobile, {
        onClear: clearHandler,
        refineCount: 0,
        itemCount: 0,
        labels: labels
    }, /*#__PURE__*/ React__default.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentRefinement,
        onChange: refine,
        renderNumber: (value)=>Math.round(value / 100)
    }))));
};
var ConnectedFacetInputPriceRangeMobile$1 = connectRange(ConnectedFacetInputPriceRangeMobile);

const FacetsMobile = ({ facets , items: items1 , refine , nbHits  })=>{
    const { getLabel  } = useIntl();
    const [hasMounted, setMounted] = useState(false);
    const [activeFacet, setActiveFacet] = useState();
    const [isVisible, setVisible] = useState(false);
    const [scrollHeight, setScrollHeight] = useState(0);
    useEffect(()=>setMounted(true)
    , []);
    const handleToggle = useCallback((attribute)=>{
        window.scrollTo(0, 0);
        setActiveFacet(activeFacet === attribute ? undefined : attribute);
    }, [
        activeFacet
    ]);
    const onShowFilters = ()=>{
        const scrollTop = window.pageYOffset;
        if (!isVisible) {
            setScrollHeight(scrollTop);
            window.scrollTo(0, 0);
        } else {
            window.scrollTo(0, scrollHeight);
        }
        setVisible(!isVisible);
    };
    const itemsToClear = useItemsToClear(items1);
    const activeFilterCount = itemsToClear.filter((item, index, items)=>items.findIndex(({ id  })=>id === item.id
        ) === index
    ).reduce((prev, curr)=>{
        const itemCount = curr.items && curr.items.length || 1;
        return prev + itemCount;
    }, 0);
    return(/*#__PURE__*/ React__default.createElement(Fragment, null, !isVisible && /*#__PURE__*/ React__default.createElement("div", {
        className: "facets-mobile-trigger"
    }, /*#__PURE__*/ React__default.createElement(Button, {
        className: "facets-mobile-trigger__button",
        caption: `${getLabel('search.filter')}
              ${activeFilterCount > 0 ? `(${activeFilterCount})` : ''}`,
        icon: "filter",
        onClick: onShowFilters
    })), hasMounted && /*#__PURE__*/ ReactDOM.createPortal(renderFacets(), document.body), isVisible && /*#__PURE__*/ React__default.createElement(HideApp, null)));
    function renderFacets() {
        const facetsClass = classnames('facets-mobile', {
            'facets-mobile--hidden': !isVisible
        });
        const facetHeaderClass = classnames('facets-mobile__header', {
            'facets-mobile__header--hidden': !!activeFacet
        });
        const facetContainerClass = classnames('facets-mobile__container', {
            'facets-mobile__container--layered': !!activeFacet
        });
        const footerButtonClass = classnames('facets-mobile__footer-button', {
            'facets-mobile__footer-button': !!activeFacet
        });
        return(/*#__PURE__*/ React__default.createElement("div", {
            className: facetsClass
        }, /*#__PURE__*/ React__default.createElement("div", {
            className: facetHeaderClass
        }, /*#__PURE__*/ React__default.createElement(Heading, {
            variant: "small",
            className: "facets-mobile__title"
        }, getLabel('products.filters'), " ", !!items1.length && `(${activeFilterCount})`), /*#__PURE__*/ React__default.createElement(ClearFacetFilter, {
            label: getLabel('search.filters.clearAll'),
            onClear: ()=>refine(itemsToClear)
            ,
            isDisabled: !itemsToClear.length
        })), /*#__PURE__*/ React__default.createElement("div", {
            className: facetContainerClass
        }, facets.map(renderFacet)), /*#__PURE__*/ React__default.createElement("div", {
            className: "facets-mobile__footer"
        }, activeFacet ? /*#__PURE__*/ React__default.createElement(Button, {
            className: footerButtonClass,
            caption: getLabel('search.filters.save'),
            variant: "outline",
            onClick: ()=>handleToggle(undefined)
        }) : /*#__PURE__*/ React__default.createElement(Button, {
            className: footerButtonClass,
            caption: activeFilterCount > 0 ? `${getLabel('search.filters.showResults')} ${nbHits}` : getLabel('search.filters.close'),
            variant: activeFilterCount > 0 ? 'solid' : 'outline',
            onClick: onShowFilters
        }))));
    }
    function renderFacet(facet) {
        switch(facet.id){
            case FacetId.price:
                return(/*#__PURE__*/ React__default.createElement(ConnectedFacetInputPriceRangeMobile$1, {
                    key: facet.attribute,
                    attribute: facet.attribute,
                    title: getLabel(facet.labelKey || facet.id),
                    isActive: activeFacet === facet.attribute,
                    onToggle: handleToggle,
                    expandedState: !!activeFacet
                }));
            default:
                return(/*#__PURE__*/ React__default.createElement(ConnectedFacetContainerMobile$1, {
                    facet: facet,
                    searchable: facet.searchable,
                    key: facet.attribute,
                    attribute: facet.attribute,
                    title: getLabel(facet.labelKey || facet.id),
                    isActive: facet.attribute === activeFacet,
                    expandedState: !!activeFacet,
                    onToggle: handleToggle,
                    limit: 100,
                    showMoreLabel: getLabel('search.filters.showMore'),
                    showLessLabel: getLabel('search.filters.showLess')
                }));
        }
    }
};
var FacetsMobile$1 = connectCurrentRefinements(connectStats(FacetsMobile));
const HideApp = ()=>{
    useEffect(()=>{
        const container = document.getElementById('app-container');
        if (container) {
            container.style.display = 'none';
        }
        return function cleanUp() {
            if (container) {
                container.style.display = '';
            }
        };
    });
    return null;
};

const ClearRefinements = ({ items , refine  })=>{
    const { getLabel  } = useIntl();
    const itemsToClear = useItemsToClear(items);
    const handleClick = React.useCallback(()=>{
        refine(itemsToClear);
    }, [
        refine,
        itemsToClear
    ]);
    if (!itemsToClear.length) {
        return null;
    }
    return(/*#__PURE__*/ React.createElement(Button, {
        className: "clear-refinements",
        onClick: handleClick,
        caption: getLabel('search.filters.clearAll'),
        variant: "ghost",
        size: "custom"
    }));
};
var ClearRefinements$1 = connectCurrentRefinements(ClearRefinements);

const CurrentRefinements = ({ items: items1 , refine  })=>{
    const { facets  } = useAlgoliaConfig();
    const intl = useIntl();
    const uniqItems = React.useMemo(()=>uniqBy(items1, (item)=>item.attribute + item.label
        )
    , [
        items1
    ]);
    const refinementItems = React.useMemo(()=>{
        return uniqItems.reduce((result, item, i)=>{
            const facet = facets.find(({ attribute  })=>attribute === item.attribute
            );
            if (!facet || facet.hidden) {
                return result;
            }
            const element = /*#__PURE__*/ React.createElement(React.Fragment, {
                key: i
            }, isRangeRefinement(item) ? renderRange(item) : item.items ? renderItems(item.items, facet) : null);
            return [
                ...result,
                element
            ];
        }, []);
    }, [
        uniqItems
    ]);
    return refinementItems.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "current-refinements"
    }, refinementItems, /*#__PURE__*/ React.createElement(ClearRefinements$1, null)) : null;
    function renderItems(items, facet) {
        return(/*#__PURE__*/ React.createElement(React.Fragment, null, items.map((item)=>/*#__PURE__*/ React.createElement("span", {
                key: item.label,
                className: "current-refinements__tag"
            }, /*#__PURE__*/ React.createElement(Tag, {
                onClick: ()=>refine(item.value)
            }, facet.showLabel && facet.labelKey && intl.hasLabel(facet.labelKey) && /*#__PURE__*/ React.createElement("span", {
                className: "current-refinements__label"
            }, intl.getLabel(facet.labelKey || facet.id), ":", ' '), getFacetOptionLabel(facet, item.label, intl).label))
        )));
    }
    function renderRange({ currentRefinement: { min , max  } , label , value  }) {
        return(/*#__PURE__*/ React.createElement("span", {
            key: label,
            className: "current-refinements__tag"
        }, /*#__PURE__*/ React.createElement(Tag, {
            onClick: ()=>refine(value)
        }, /*#__PURE__*/ React.createElement(Price, {
            value: Math.round(min / 100),
            currency: intl.currency,
            centAmount: false
        }), ' – ', /*#__PURE__*/ React.createElement(Price, {
            value: Math.round(max / 100),
            currency: intl.currency,
            centAmount: false
        }))));
    }
};
var CurrentRefinements$1 = connectCurrentRefinements(CurrentRefinements);
function isRangeRefinement(refinement) {
    const currentRefiment = refinement.currentRefinement;
    return currentRefiment.hasOwnProperty('min') || currentRefiment.hasOwnProperty('max');
}

function FacetHeader({ title , onSearch , onClear , enableClearButton  }) {
    const intl = useIntl();
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: "facet-header"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "facet-header__heading"
    }, /*#__PURE__*/ React__default.createElement("span", null, title), onClear && /*#__PURE__*/ React__default.createElement(ClearFacetFilter, {
        onClear: onClear,
        isDisabled: !enableClearButton,
        label: intl.getLabel('search.filters.clear', {
            defaultValue: 'clear'
        })
    })), onSearch && /*#__PURE__*/ React__default.createElement(FacetSearchBox, {
        placeholder: intl.getLabel('search.filters.placeholder'),
        onSearch: (event)=>onSearch(event.target.value)
    })));
}

const FacetContainer = ({ title , onClear , onSearch , children , enableClearButton ,  })=>{
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: "facet-container"
    }, /*#__PURE__*/ React__default.createElement(FacetHeader, {
        title: title,
        enableClearButton: enableClearButton,
        onSearch: onSearch,
        onClear: onClear
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "facet-container__inner"
    }, children)));
};

const FacetInputList = ({ items , onRefine , facet  })=>{
    const sortedItems = orderFacetOptions({
        facet,
        items
    });
    return(/*#__PURE__*/ React__default.createElement(AnimatePresence, null, sortedItems.map((item)=>/*#__PURE__*/ React__default.createElement(motion.div, {
            variants: facetInputItemVariants,
            key: item.label
        }, /*#__PURE__*/ React__default.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: onRefine
        }))
    )));
};
const facetInputItemVariants = {
    flip: {
        transition: {
            type: 'spring',
            stiffness: 500,
            damping: 800
        }
    }
};

var ConnectedFacetInputList = connectRefinementList(ConnectedFacetInputList$1);
function ConnectedFacetInputList$1({ facet , attribute , items , refine , isActive , onToggle , searchable , searchForItems , isFromSearch  }) {
    const intl = useIntl();
    if (!items.length && !isFromSearch) {
        return null;
    }
    const refineCount = items.filter((x)=>x.isRefined
    ).length;
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: "connected-facet-input-list"
    }, /*#__PURE__*/ React__default.createElement(ButtonWithDropdown, {
        title: intl.getLabel(facet.labelKey || facet.id),
        onClick: ()=>onToggle(attribute)
        ,
        isActive: isActive,
        label: intl.getLabel(facet.labelKey || facet.id),
        className: "connected-facet-input-list__button"
    }, /*#__PURE__*/ React__default.createElement(FacetContainer, {
        onSearch: searchable ? searchForItems : undefined,
        onClear: ()=>refine([])
        ,
        enableClearButton: refineCount > 0,
        title: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, refineCount, ' ', intl.getLabel('search.filters.selected', {
            defaultValue: 'selected'
        }))
    }, /*#__PURE__*/ React__default.createElement(FacetInputList, {
        facet: facet,
        items: items,
        onRefine: refine
    })))));
}

var ConnectedFacetInputPriceRange = connectRange(ConnectedFacetInputPriceRange$1);
function ConnectedFacetInputPriceRange$1({ facet , attribute , refine , isActive , onToggle , min , max , currentRefinement  }) {
    const clearHandler = useCallback(()=>refine({
            min,
            max
        })
    , [
        min,
        max
    ]);
    const intl = useIntl();
    if (min === max) {
        return null;
    }
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: "connected-facet-input-range"
    }, /*#__PURE__*/ React__default.createElement(ButtonWithDropdown, {
        title: intl.getLabel(facet.labelKey || facet.id),
        onClick: ()=>onToggle(attribute)
        ,
        isActive: isActive,
        label: intl.getLabel(facet.labelKey || facet.id),
        className: "connected-facet-input-range__button"
    }, /*#__PURE__*/ React__default.createElement(FacetContainer, {
        onClear: clearHandler,
        enableClearButton: currentRefinement.min !== min || currentRefinement.max !== max,
        title: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Price, {
            value: roundPrice(currentRefinement.min),
            currency: intl.currency,
            centAmount: false
        }), ' – ', /*#__PURE__*/ React__default.createElement(Price, {
            value: roundPrice(currentRefinement.max),
            currency: intl.currency,
            centAmount: false
        }))
    }, /*#__PURE__*/ React__default.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentRefinement,
        onChange: refine,
        renderNumber: roundPrice
    })))));
}
function roundPrice(value) {
    return Math.round(value / 100);
}

const FacetsDesktop = ({ facets  })=>{
    const [activeFacet, setActiveFacet] = useState();
    const handleToggle = useCallback((attribute)=>setActiveFacet(activeFacet === attribute ? undefined : attribute)
    , [
        activeFacet
    ]);
    const ref = React__default.useRef(null);
    useOnClickOutside(ref, ()=>setActiveFacet(undefined)
    );
    return(/*#__PURE__*/ React__default.createElement("div", {
        className: "facets-desktop"
    }, /*#__PURE__*/ React__default.createElement("div", {
        ref: ref,
        className: "facets-desktop__top-bar"
    }, facets.map((facet)=>/*#__PURE__*/ React__default.createElement(Fragment, {
            key: facet.attribute
        }, renderFacet(facet))
    )), /*#__PURE__*/ React__default.createElement("div", {
        className: "facets-desktop__refinements"
    }, /*#__PURE__*/ React__default.createElement(CurrentRefinements$1, null))));
    function renderFacet(facet) {
        switch(facet.id){
            case FacetId.price:
                return(/*#__PURE__*/ React__default.createElement(ConnectedFacetInputPriceRange, {
                    key: facet.attribute,
                    facet: facet,
                    attribute: facet.attribute,
                    isActive: facet.attribute === activeFacet,
                    onToggle: handleToggle
                }));
            default:
                return(/*#__PURE__*/ React__default.createElement(ConnectedFacetInputList, {
                    key: facet.attribute,
                    facet: facet,
                    attribute: facet.attribute,
                    isActive: facet.attribute === activeFacet,
                    onToggle: handleToggle,
                    searchable: facet.searchable,
                    limit: 100
                }));
        }
    }
};

const noOp = ()=>null
;
const VirtualSortBy = connectSortBy(noOp);
const VirtualRefinementList = connectRefinementList$1(noOp);
const VirtualRange = connectRange$1(noOp);
const VirtualSearchBox = connectSearchBox(noOp);
const VirtualInfinitePagination = ({ pageSize , searchState  })=>{
    var ref;
    // On the server, set the offset so we start at the latest viewed page so only those results are fetched
    // E.G page=3 will result in offset=72 length=24
    const offset = ((ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.offset) || 0;
    return(/*#__PURE__*/ React__default.createElement(Configure$1, {
        offset: offset,
        length: pageSize
    }));
};
/**
 * VirtualFacets should never render HTML
 */ const VirtualFacets = ()=>{
    const { facets , sortIndices , filters , pageSize , ruleContexts , algoliaInstantSearchProps: { searchState  } , facetingAfterDistinct ,  } = useAlgoliaConfig();
    return(/*#__PURE__*/ React__default.createElement(Fragment, null, /*#__PURE__*/ React__default.createElement(Configure$1, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), sortIndices.length > 0 && /*#__PURE__*/ React__default.createElement(VirtualSortBy, {
        defaultRefinement: sortIndices[0].value,
        items: sortIndices
    }), /*#__PURE__*/ React__default.createElement(VirtualInfinitePagination, {
        pageSize: pageSize,
        searchState: searchState
    }), /*#__PURE__*/ React__default.createElement(VirtualSearchBox, null), facets.map((facet)=>{
        switch(facet.id){
            case FacetId.price:
                return(/*#__PURE__*/ React__default.createElement(VirtualRange, {
                    key: facet.attribute,
                    attribute: facet.attribute
                }));
            default:
                return(/*#__PURE__*/ React__default.createElement(VirtualRefinementList, {
                    key: facet.attribute,
                    attribute: facet.attribute,
                    defaultRefinement: facet.value,
                    limit: 100
                }));
        }
    }), /*#__PURE__*/ React__default.createElement(Configure$1, {
        filters: filters,
        ruleContexts: ruleContexts
    })));
};

const SortBy = ({ items , refine , currentRefinement  })=>{
    const selected = items.find((item)=>item.value === currentRefinement
    );
    const intl = useIntl();
    return(/*#__PURE__*/ React.createElement("div", {
        className: "search-sort"
    }, /*#__PURE__*/ React.createElement("select", {
        className: "search-sort__select",
        value: currentRefinement,
        onChange: (evt)=>refine(evt.target.value)
    }, items.map((item)=>/*#__PURE__*/ React.createElement("option", {
            key: item.value,
            value: item.value,
            "aria-selected": true
        }, getLabel(item))
    )), /*#__PURE__*/ React.createElement("div", {
        className: "search-sort__content"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "search-sort__sort-by"
    }, selected && getLabel(selected)), /*#__PURE__*/ React.createElement("span", {
        className: "search-sort__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-down"
    })))));
    function getLabel(item) {
        const label = item.label ? item.label : item.labelKey ? intl.getLabel(item.labelKey) : '';
        if (!label) {
            console.error('A sort-item is missing both label as labelKey');
        }
        return label;
    }
};
var SortBy$1 = connectSortBy(SortBy);

const PRICE_FROM_PARAM = FacetId.price + 'From';
const PRICE_TO_PARAM = FacetId.price + 'To';
const QUERY_KEYS = [
    'q',
    'page',
    'sortBy',
    PRICE_FROM_PARAM,
    PRICE_TO_PARAM
];
function getQueryParamsFromUri(uri = '') {
    return decode(uri.split('?')[1] || '');
}
function getQueryKey(key1, facets) {
    const keys = QUERY_KEYS.concat(facets.map((f)=>f.id
    ));
    const lookup = keys.reduce((result, key)=>{
        result[key.toLowerCase()] = key;
        return result;
    }, {});
    return lookup[key1.toLowerCase()];
}
function getNonQueryObject(uri, { facets  }) {
    return Object.entries(getQueryParamsFromUri(uri)).reduce((result, [key, value])=>{
        if (!getQueryKey(key, facets)) {
            result[key] = value;
        }
        return result;
    }, {});
}
function queryStringToQueryObject(uri, { facets  }) {
    return Object.entries(getQueryParamsFromUri(uri)).reduce((result, [key, value])=>{
        const translatedKey = getQueryKey(key, facets);
        if (translatedKey) {
            result[translatedKey] = value;
        }
        return result;
    }, {});
}
function queryStringToSearchState(uri, qsOptions) {
    return queryObjectToSearchState(queryStringToQueryObject(uri, qsOptions), qsOptions);
}
function searchStateToQueryObject(searchState, { facets , pageSize , sortIndices , presetQueryObject  }) {
    const facetsVisible = facets.filter(isFacetVisible);
    return flowRight(addPage, addSort, addQuery, addPriceRange, addRefinementListAttributes)({});
    function addPage(queryObject) {
        var ref;
        const { length , page , offset  } = searchState.configure || {
            length: pageSize,
            page: 1,
            offset: 0
        };
        let newPageIndex = page;
        if (length - offset === pageSize) {
            //Server.
            newPageIndex = offset === 0 ? page + 1 : page;
        }
        if (offset === 0 && length > pageSize) {
            // Client. We're not on page one so we calculate the page
            newPageIndex = Math.ceil(length / pageSize);
        }
        if (offset === 0 && length === pageSize && ((ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.filters)) {
            // If a filter is enabled we set the page back to one
            searchState.configure.page = 1;
            newPageIndex = 1;
        }
        if (newPageIndex > 1) {
            queryObject.page = newPageIndex.toString();
        }
        return queryObject;
    }
    function addSort(queryObject) {
        const { sortBy  } = searchState;
        const sortIndex = sortIndices.find((x)=>x.value === sortBy
        );
        const isDefaultSortIndex = presetQueryObject.sortBy ? sortIndex && sortIndex.id === presetQueryObject.sortBy : sortIndex && sortIndex.id === sortIndices[0].id;
        if (sortIndex && sortIndex.id && !isDefaultSortIndex) {
            queryObject.sortBy = sortIndex.id;
        }
        return queryObject;
    }
    function addQuery(queryObject) {
        if (!presetQueryObject.q && searchState.query) {
            queryObject.q = searchState.query;
        }
        return queryObject;
    }
    function addPriceRange(queryObject) {
        const facet = facetsVisible.find((f)=>f.id === FacetId.price
        );
        const value = facet && searchState.range && searchState.range[facet.attribute];
        if (facet && value && (value.min || value.max)) {
            value.min && (queryObject[PRICE_FROM_PARAM] = Math.round(value.min / 100).toString());
            value.max && (queryObject[PRICE_TO_PARAM] = Math.round(value.max / 100).toString());
        }
        return queryObject;
    }
    function addRefinementListAttributes(queryObject) {
        Object.entries(searchState.refinementList || {}).forEach(([attribute, value])=>{
            const facet = facetsVisible.find((f)=>f.attribute === attribute
            );
            if (facet && value.length) {
                queryObject[facet.id] = value;
            }
        }, {});
        return queryObject;
    }
}
function queryObjectToSearchState(queryObject, { facets , pageSize , sortIndices , isCreatingPresetState , presetQueryObject  }) {
    const facetsVisible = isCreatingPresetState ? facets : facets.filter(isFacetVisible);
    return flowRight(isCreatingPresetState ? skip : addPage, addSort, addQuery, addPriceRange, addRefinementListAttributes)({
        configure: {
            aroundLatLng: false
        },
        refinementList: {},
        range: {}
    });
    function addPage(searchState) {
        var ref;
        if (queryObject.page && ((ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.offset) !== 0) {
            const page = Math.max(1, parseInt(queryObject.page, 10));
            searchState.configure.page = page;
            searchState.configure.offset = Math.min((page - 1) * pageSize, 999);
            searchState.configure.length = Math.min(page * pageSize, 999);
        }
        return searchState;
    }
    function addSort(searchState) {
        const { sortBy  } = queryObject;
        const { value =null  } = sortIndices.find((x)=>x.id === sortBy
        ) || {};
        if (value) {
            searchState.sortBy = value;
        }
        return searchState;
    }
    function addQuery(searchState) {
        const query = presetQueryObject.q || queryObject.q;
        if (query) {
            searchState.query = query;
        }
        return searchState;
    }
    function addPriceRange(searchState) {
        const facet = facetsVisible.find((f)=>f.id === FacetId.price
        );
        const priceKeys = [
            queryObject[PRICE_FROM_PARAM],
            queryObject[PRICE_TO_PARAM], 
        ];
        const [min, max] = priceKeys.map((x)=>(parseFloat(x || '') || 0) * 100
        );
        if (facet && (min || max)) {
            searchState.range[facet.attribute] = {};
            min && (searchState.range[facet.attribute].min = min);
            max && (searchState.range[facet.attribute].max = max);
        }
        return searchState;
    }
    function addRefinementListAttributes(searchState) {
        Object.entries(queryObject).forEach(([id, values])=>{
            values = [].concat(values);
            const facet = values.length && facetsVisible.find((f)=>f.id === id
            );
            if (facet) {
                searchState.refinementList[facet.attribute] = values;
            }
        });
        return searchState;
    }
}
const skip = (x)=>x
;

function _defineProperty$6(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$6(target, key, source[key]);
        });
    }
    return target;
}
const useQueryChange = (NextRouter, searchState, clientQueryString)=>{
    const { facets , sortIndices , pageSize , presetQueryObject  } = useAlgoliaConfig();
    const { queryObject , nonQueryObject  } = useMemo(()=>({
            queryObject: searchStateToQueryObject(searchState, {
                facets,
                sortIndices,
                pageSize,
                presetQueryObject
            }),
            nonQueryObject: getNonQueryObject(clientQueryString, {
                facets
            })
        })
    , [
        searchState,
        JSON.stringify(facets),
        sortIndices,
        pageSize
    ]);
    const query = useMemo(()=>_objectSpread$6({}, queryObject, nonQueryObject)
    , [
        JSON.stringify(queryObject),
        JSON.stringify(nonQueryObject), 
    ]);
    useDebouncedEffect(()=>{
        const [pathWithoutHash, hash] = (NextRouter.asPath || '').split('#');
        const pathname = pathWithoutHash.split('?')[0];
        NextRouter.replace({
            pathname: NextRouter.pathname,
            query
        }, {
            pathname,
            query,
            hash
        }, {
            shallow: true
        });
    }, 500, [
        query
    ]);
};
function UseQueryChange({ NextRouter , searchState , clientQueryString  }) {
    useQueryChange(NextRouter, searchState, clientQueryString);
    return null;
}

function _defineProperty$5(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$5(target, key, source[key]);
        });
    }
    return target;
}
function AlgoliaConfigProvider(props) {
    const { isEnabled , resultsState , clientQueryString , presetQueryString , NextRouter , ruleContexts , locale , facetingAfterDistinct ,  } = props;
    const { apiKey , appId , filters , indexName , pageSize =24  } = props.options;
    const searchClient = useMemo(()=>algoliaSearch(appId, apiKey)
    , [
        appId,
        apiKey
    ]);
    const { facets: facets1 , sortIndices: sortIndices1 , presetQueryObject: presetQueryObject1 , initialSearchState: initialSearchState1  } = useMemo(()=>{
        const facets = configureFacets(props.options.facets, locale, presetQueryString);
        const sortIndices = props.options.sortIndices.filter(({ value  })=>value
        );
        const qsOptions = {
            facets,
            pageSize,
            sortIndices,
            presetQueryObject: {}
        };
        const presetQueryObject = queryStringToQueryObject(presetQueryString, qsOptions);
        const presetQueryState = queryObjectToSearchState(presetQueryObject, _objectSpread$5({}, qsOptions, {
            isCreatingPresetState: true,
            presetQueryObject
        }));
        const clientQueryState = queryStringToSearchState(clientQueryString, _objectSpread$5({}, qsOptions, {
            presetQueryObject
        }));
        const initialSearchState = merge(presetQueryState, clientQueryState);
        return {
            facets,
            sortIndices,
            presetQueryObject,
            initialSearchState
        };
    }, [
        props.options.facets,
        props.options.sortIndices,
        locale,
        presetQueryString,
        pageSize,
        clientQueryString, 
    ]);
    const [searchState, onSearchStateChange] = useState(initialSearchState1);
    const value1 = useMemo(()=>({
            isEnabled,
            pageSize,
            filters,
            facets: facets1,
            facetingAfterDistinct,
            sortIndices: sortIndices1,
            presetQueryObject: presetQueryObject1,
            ruleContexts,
            algoliaInstantSearchProps: {
                onSearchStateChange,
                indexName,
                resultsState,
                searchState,
                searchClient
            }
        })
    , [
        isEnabled,
        pageSize,
        filters,
        facets1,
        facetingAfterDistinct,
        sortIndices1,
        presetQueryObject1,
        ruleContexts,
        indexName,
        resultsState,
        searchState,
        searchClient, 
    ]);
    return(/*#__PURE__*/ React__default.createElement(AlgoliaConfig.Provider, {
        value: value1
    }, isEnabled && NextRouter && /*#__PURE__*/ React__default.createElement(UseQueryChange, {
        NextRouter: NextRouter,
        searchState: searchState,
        clientQueryString: clientQueryString
    }), props.children));
}
function configureFacets(facets, locale, presetQueryString) {
    const presetKeyVal = Object.entries(queryStringToQueryObject(presetQueryString || '', {
        facets
    })).reduce((result, [key, value])=>{
        result[key.toLowerCase()] = value;
        return result;
    }, {});
    return facets.map((facet)=>{
        const rawValue = presetKeyVal[facet.id.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue : rawValue ? [
            rawValue
        ] : [];
        let hidden = facet.hidden || !!value.length;
        if (facet.id === FacetId.price) {
            const hasPriceFrom = presetKeyVal.hasOwnProperty(PRICE_FROM_PARAM.toLowerCase());
            const hasPriceTo = presetKeyVal.hasOwnProperty(PRICE_TO_PARAM.toLowerCase());
            hidden = hidden || hasPriceFrom || hasPriceTo;
        }
        return _objectSpread$5({}, facet, {
            options: facet.options && lowercaseKeys(facet.options),
            value: value.length ? value : undefined,
            attribute: facet.isLocalized ? `${facet.attribute}_${locale}` : facet.attribute,
            hidden
        });
    });
}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((result, key)=>{
        result[key.toLowerCase()] = obj[key];
        return result;
    }, {});
}

function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty$4(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$4(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AlgoliaSearch({ children  }) {
    const { algoliaInstantSearchProps , isEnabled , facetingAfterDistinct  } = useAlgoliaConfig();
    return(/*#__PURE__*/ React__default.createElement(InstantSearch, _extends$1({}, algoliaInstantSearchProps), /*#__PURE__*/ React__default.createElement(VirtualFacets, null), /*#__PURE__*/ React__default.createElement(Configure$1, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), /*#__PURE__*/ React__default.createElement(WithStateResults, {
        isEnabled: isEnabled
    }, children)));
}
const WithStateResults = connectStateResults$1((_param)=>{
    var { children , isEnabled  } = _param, stateResults = _objectWithoutProperties(_param, [
        "children",
        "isEnabled"
    ]);
    return children(isEnabled ? stateResults : null);
});
function fetchAlgoliaConfig(props) {
    return _fetchAlgoliaConfig.apply(this, arguments);
}
function _fetchAlgoliaConfig() {
    _fetchAlgoliaConfig = _asyncToGenerator$2(function*(props) {
        if (!props.isEnabled) {
            return props;
        }
        const { appId , apiKey  } = props.options;
        const searchClient = algoliaSearch(appId, apiKey);
        try {
            return _objectSpread$4({}, props, {
                resultsState: yield findResultsState((providedProps)=>{
                    return(/*#__PURE__*/ React__default.createElement(AlgoliaConfigProvider, _extends$1({}, props), /*#__PURE__*/ React__default.createElement(InstantSearchContainer, _extends$1({}, providedProps), /*#__PURE__*/ React__default.createElement(VirtualFacets, null))));
                }, _objectSpread$4({
                    searchClient
                }, props.options))
            });
        } catch (err) {
            console.log('An error occured while fetching algolia hits');
            console.error(err);
            return _objectSpread$4({}, props, {
                isEnabled: false
            });
        }
    });
    return _fetchAlgoliaConfig.apply(this, arguments);
}
const InstantSearchContainer = (props)=>{
    const { algoliaInstantSearchProps  } = useAlgoliaConfig();
    return(/*#__PURE__*/ React__default.createElement(InstantSearch, _extends$1({}, algoliaInstantSearchProps, props), props.children));
};

const ALGOLIA_INSIGHTS_VERSION = packageInfo.version;
const AlgoliaAnalytics = ({ appId , apiKey  })=>{
    const consentResult = useCookieConsentContext();
    if (!apiKey || !appId || !ALGOLIA_INSIGHTS_VERSION) {
        console.warn('Unable to initialize Algolia Insights! Check the appId, apiKey and the search-insights package version.');
        return null;
    }
    return(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("link", {
        rel: "preconnect",
        href: "https://cdn.jsdelivr.net/"
    }), /*#__PURE__*/ React.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@${ALGOLIA_INSIGHTS_VERSION}";
  !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
  (e[s].queue=e[s].queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],
  i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
  }(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");
  // Initialize library
  // TODO: move this to AlgoliaConfig
  aa('init', {
    appId: "${appId}",
    apiKey: "${apiKey}",
    useCookie: ${isCookieCategoryEnabled('analytics', consentResult)}
  });`
        }
    })));
};

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty$3(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$3(target, key, source[key]);
        });
    }
    return target;
}
function queryAlgolia(algoliaConfig, searchOptions) {
    return _queryAlgolia.apply(this, arguments);
}
function _queryAlgolia() {
    _queryAlgolia = _asyncToGenerator$1(function*(algoliaConfig, searchOptions) {
        const { apiKey , appId , indexName  } = algoliaConfig;
        if (!apiKey || !appId || !indexName) {
            console.error(`[queryAlgolia]: missing ApiKey: ${apiKey}, AppId:  ${appId} or indexName : ${indexName} `);
            return null;
        }
        /**
   * Initialize search client and index
   */ const client = algoliaSearch(appId, apiKey);
        const index = client.initIndex(indexName);
        if (!index) {
            console.error(`[queryAlgolia]: Cannot search on uninstantiated index.`);
            return null;
        }
        try {
            const result = yield index.search(searchOptions.query || '', _objectSpread$3({}, searchOptions));
            return result;
        } catch (e) {
            console.error(`[queryAlgolia]: Something went wrong searching Algolia.`);
            return null;
        }
    });
    return _queryAlgolia.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty$2(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$2(target, key, source[key]);
        });
    }
    return target;
}
function useAlgoliaSearch(algoliaConfig, searchOptions) {
    const isSubscribed = React.useRef(true);
    const [state1, setState] = React.useState({
        result: [],
        hasError: false,
        isLoading: false
    });
    React.useEffect(()=>{
        !state1.isLoading && search();
        function search() {
            return _search.apply(this, arguments);
        }
        function _search() {
            _search = _asyncToGenerator(function*() {
                setState((state)=>_objectSpread$2({}, state, {
                        isLoading: true
                    })
                );
                const result = yield queryAlgolia(algoliaConfig, searchOptions);
                if (result === null) {
                    console.error(`[useAlgoliaSearch]: Something went wrong searching Algolia.`);
                    isSubscribed.current && setState((state)=>_objectSpread$2({}, state, {
                            hasError: true,
                            isLoading: false
                        })
                    );
                    return;
                }
                isSubscribed.current && setState((state)=>_objectSpread$2({}, state, {
                        result: result.hits,
                        isLoading: false
                    })
                );
            });
            return _search.apply(this, arguments);
        }
        return ()=>{
            isSubscribed.current = false;
        };
    }, [
        searchOptions,
        algoliaConfig
    ]);
    return state1;
}

var AlgoliaFilterOperator;
(function(AlgoliaFilterOperator) {
    AlgoliaFilterOperator["OR"] = "OR";
    AlgoliaFilterOperator["NOT"] = "NOT";
    AlgoliaFilterOperator["AND"] = "AND";
    AlgoliaFilterOperator["AND_NOT"] = 'AND NOT';
})(AlgoliaFilterOperator || (AlgoliaFilterOperator = {}));
/**
 * Helper to return a filter based on id and value.
 * If the facet-value contains spaces, we should enclose it in quotes
 */ const getFilter = (id, value)=>{
    const escapedValue = typeof value === 'string' && value.includes(' ') ? `'${value}'` : value;
    return `${id}:${escapedValue}`;
};
function createAlgoliaFilters(filterableAttributes, operator, prefix) {
    if (!filterableAttributes.length) {
        return operator || prefix ? '' : [];
    }
    /**
   * Iterate over the filterableAttributes
   * Based on the type of value create a filter string
   */ const filters = filterableAttributes.reduce((prev, { id , value  })=>{
        /**
     * If the value is a simple string, return the value:
     * `<filterName>:<filterValue>`
     */ if (typeof value === 'string') {
            const result = getFilter(id, value);
            prev.push(result);
        }
        /**
     * If the value is an array, create a string with the OR operator between values encapsulated by `()`
     *  `(<filterName>:<filterValue1> OR <filterName>:<filterValue2> OR <filterName>:<filterValue2>)`
     */ if (Array.isArray(value)) {
            const result = value.map((val)=>getFilter(id, val)
            ).join(` ${AlgoliaFilterOperator.OR} `);
            const filterString = value.length > 1 ? `(${result})` : result;
            prev.push(filterString);
        }
        return prev;
    }, []);
    /**
   * If an operator or prefix is defined, adjust the string:
   * `<Prefix> <filterName1>:<filterValue> <Operator> <filterName2>:<filterValue>`
   */ if (operator || prefix) {
        return `${prefix ? `${prefix} ` : ''}${filters.join(` ${operator} `)}`;
    } else {
        return filters;
    }
}

/**
 * Creates a filter string for a given array of sku's.
 */ function createFiltersFromSkus(skus) {
    if (skus.length === 0) {
        return '';
    }
    const filterableSkus = skus.filter(Boolean).map((sku)=>({
            id: 'masterVariant.sku',
            value: sku
        })
    );
    return createAlgoliaFilters(filterableSkus, AlgoliaFilterOperator.OR);
}
/**
 * Returns a filter string based on the query string
 * The queryParameters are extracted and stored in an object containing the parameter and the value(s)
 * This object is matched to the given facets so only the existing facets are used.
 */ function createFiltersFromQuery(query, facets) {
    if (!query || !facets) {
        return '';
    }
    /**
   * Convert the querystring to an object of attributes,
   * These attributes are checked against the configured facets
   * Only existing attributes are returned.
   */ const queryObject = queryStringToQueryObject(query, {
        facets
    });
    /**
   * Iterate over the keys and for each entry create a FilterableAttribute
   */ const filterableAttributes = Object.keys(queryObject).map((filterKey)=>{
        // Find the facet belonging to the filter
        const attribute = facets === null || facets === void 0 ? void 0 : facets.find((facet)=>facet.id === filterKey
        );
        const value = queryObject[filterKey];
        if (!attribute || !attribute.attribute) {
            return null;
        }
        return {
            id: attribute.attribute,
            value
        };
    })// Filter only valid FilterableAttributes
    .filter((val)=>val !== null && Boolean(val.id)
    );
    return createAlgoliaFilters(filterableAttributes, AlgoliaFilterOperator.AND);
}

/**
 * QueryAlgoliaProducts is a component that mainly wraps the `useAlgoliaSearch` hook.
 * Based on the supplied the props `skus`, `queryString` and `ruleContext`  we map the data for querying Algolia.
 * This component expects a render function as a child which takes the searchResults as an argument.
 */ function QueryAlgoliaProducts({ skus , queryString , ruleContext , algoliaConfig , children  }) {
    /**
   * Prepare options for searching
   * Creates the filters based on the given sku's or the queryString
   * The skus gets priority over the queryString when both are defined.
   */ const searchOptions = React__default.useMemo(()=>{
        const ruleContexts = typeof ruleContext === 'string' ? [
            ruleContext
        ] : ruleContext;
        const filters = skus.length > 0 ? createFiltersFromSkus(skus) : createFiltersFromQuery(queryString, algoliaConfig.facets);
        return {
            filters,
            ruleContexts
        };
    }, [
        skus,
        ruleContext,
        queryString,
        algoliaConfig
    ]);
    const result = useAlgoliaSearch(algoliaConfig, searchOptions);
    return(/*#__PURE__*/ React__default.createElement(React__default.Fragment, null, children(result)));
}

const SearchPageDescription = ({ description  })=>{
    const { getLabel  } = useIntl();
    const isMobile = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const initialHeight = isMobile ? 64 : 72;
    return(/*#__PURE__*/ React.createElement(Expandable, {
        id: "searchpage-description",
        className: "searchpage-description",
        showLessLabel: `- ${getLabel('search.filters.showLess')}`,
        showMoreLabel: `+ ${getLabel('search.filters.showMore')}`,
        initialHeight: initialHeight
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: description,
        className: "searchpage-description__body"
    })));
};

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const SearchPageHeader = ({ pageTitle , hitTitle , description  })=>{
    const { getLabel  } = useIntl();
    const { facets , algoliaInstantSearchProps , sortIndices , facetingAfterDistinct ,  } = useAlgoliaConfig();
    const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    const hasProductType = hasProductTypeFacet(algoliaInstantSearchProps.searchState, facets);
    const facetsVisible = facets.filter((facet)=>isFacetVisible(facet) && (hasProductType || PrimaryFacets[facet.id])
    );
    /**
   * In this component we're mounting a new InstantSearch component to prevent resetting
   * refinements when refinementLists unmount. We basically implemented this solution:
   * https://www.algolia.com/doc/guides/building-search-ui/going-further/native/react/?language=react#create-a-modal
   */ return(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(InstantSearch, _extends({
        key: isMobile ? 'facets-mobile' : 'facets-desktop'
    }, algoliaInstantSearchProps), /*#__PURE__*/ React.createElement(VirtualFacets, null), /*#__PURE__*/ React.createElement(Configure$1, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header"
    }, /*#__PURE__*/ React.createElement(Container, {
        className: "search-page-header__container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__intro"
    }, pageTitle && /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        component: "h1",
        className: "search-page-header__title"
    }, pageTitle), description && /*#__PURE__*/ React.createElement(SearchPageDescription, {
        description: description
    })), isMobile && /*#__PURE__*/ React.createElement(FacetsMobile$1, {
        facets: facetsVisible
    }), (hitTitle || sortIndices) && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-results"
    }, hitTitle && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__amount-hits"
    }, hitTitle), sortIndices && sortIndices.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "search-page-header__sort-by"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "search-page-header__sort-by-label"
    }, getLabel('search.results.sort.sortBy')), /*#__PURE__*/ React.createElement(SortBy$1, {
        defaultRefinement: sortIndices[0].value,
        items: sortIndices
    })))), !isMobile && /*#__PURE__*/ React.createElement(FacetsDesktop, {
        facets: facetsVisible
    })))));
};
function hasProductTypeFacet(searchState, facets) {
    const productTypeFacet = facets.find((facet)=>facet.id === FacetId.productType
    );
    const val = productTypeFacet && searchState.refinementList && searchState.refinementList[productTypeFacet.attribute];
    return (val || []).length > 0;
}

function _defineProperty$1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        });
    }
    return target;
}
function getForwardedQueryParamsFromFacets(facets, currentRefinements) {
    const params = facets.reduce((result, facet)=>{
        if (!currentRefinements || Object.keys(currentRefinements).length === 0) {
            return result;
        }
        if (facet.forwardAsQueryParam && facet.attribute in currentRefinements && Boolean(currentRefinements[facet.attribute])) {
            return _objectSpread$1({}, result, {
                [facet.id]: currentRefinements[facet.attribute].join(',')
            });
        }
        return result;
    }, {});
    if (Object.keys(params).length === 0) {
        return undefined;
    }
    return params;
}

function useInfinitePageLength(searchState, pageSize) {
    var ref;
    const previousSearchStateRef = React.useRef(searchState);
    const lengthFromState = parseInt((ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.length, 10);
    const [length, setLength] = React.useState(lengthFromState || pageSize);
    const setLengthCallback = React.useCallback(()=>{
        setLength(length + pageSize);
    }, [
        length,
        pageSize
    ]);
    React.useEffect(()=>{
        const { refinementList , range  } = previousSearchStateRef.current;
        if (length !== pageSize && (!isEqual(refinementList, searchState.refinementList) || !isEqual(range, searchState.range))) {
            // reset page size when a refinements are mutated
            setLength(pageSize);
            if (searchState.configure) {
                searchState.configure.offset = 0;
                searchState.configure.length = pageSize;
                searchState.configure.page = 1;
            }
        }
        previousSearchStateRef.current = searchState;
    }, [
        JSON.stringify(searchState),
        length,
        pageSize
    ]);
    return [
        length,
        setLengthCallback
    ];
}

const ConnectedInfinitePagination = ({ searchResults , searchState , searching ,  })=>{
    var ref;
    const { getLabel  } = useIntl();
    const { pageSize =24  } = useAlgoliaConfig();
    const [length, setLength] = useInfinitePageLength(searchState, pageSize);
    return(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Configure$1, {
        offset: 0,
        length: length
    }), /*#__PURE__*/ React.createElement(InfinitePagination, {
        onClick: setLength,
        buttonLabel: getLabel('search.loadMore'),
        labelKey: "search.pagingStatus",
        loaded: length,
        isLoading: searching,
        total: searchResults.nbHits,
        pageNr: (ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.page
    })));
};
var ConnectedInfinitePagination$1 = connectStateResults(ConnectedInfinitePagination);

function createPagedHits(hits, total, size, fill = 0) {
    const max = Math.ceil(hits.length / size);
    const pages = Array.from({
        length: fill
    }, ()=>null
    );
    for(let i = 0; i < max; i++){
        const start = i * size;
        const end = (i + 1) * size;
        const page = hits.slice(start, end);
        pages.push(page);
    }
    return {
        total,
        size,
        pages
    };
}

function ConnectedProductListing({ staticsUrl , formatProductUrl , searchResults , searchState , promotionBig , promotionSmall , reimbursableLogos  }) {
    const { getLabel , locale  } = useIntl();
    const { pageSize , facets  } = useAlgoliaConfig();
    const { hits , nbHits: total  } = searchResults;
    const { query , configure , refinementList  } = searchState;
    const page = (configure === null || configure === void 0 ? void 0 : configure.page) || 1;
    /**
   * Facets can be configured to be forwarded on PDP urls when they are active
   * for prefilling information on the PDP
   */ const forwardedQueryParams = getForwardedQueryParamsFromFacets(facets, refinementList);
    /**
   * Creates a paged object of the hits we got from algolia.
   * If the amount of hits is lower than the amount of items we should render according to
   * the page number provided trough the URL, it means we should fill the page with the amount
   * of pages that can't be rendered yet, because the server-sided, only the last page is fetched
   */ const pages = React__default.useMemo(()=>{
        const fill = page * pageSize > hits.length && hits.length !== total ? page - 1 : 0;
        return createPagedHits(hits, total, pageSize, fill);
    }, [
        hits,
        total,
        pageSize,
        page
    ]);
    if (hits.length === 0) {
        return(/*#__PURE__*/ React__default.createElement(NoResults, {
            title: getLabel('search.noResults.title'),
            description: getLabel('search.noResults.text'),
            query: query
        }));
    }
    return(/*#__PURE__*/ React__default.createElement(Fragment, null, /*#__PURE__*/ React__default.createElement(ProductListing, {
        products: pages,
        formatProductUrl: formatProductUrl,
        staticsUrl: staticsUrl,
        showMoreButton: /*#__PURE__*/ React__default.createElement(ConnectedInfinitePagination$1, null),
        promotionBig: promotionBig,
        promotionSmall: promotionSmall,
        reimbursableLogos: reimbursableLogos,
        forwardedQueryParams: forwardedQueryParams
    }), /*#__PURE__*/ React__default.createElement(ProductsSd, {
        // TODO: SD components don't accept the light product model currently
        items: hits,
        formatProductUrl: formatProductUrl,
        staticsUrl: staticsUrl,
        locale: locale
    })));
}
var ConnectedProductListing$1 = connectStateResults(ConnectedProductListing);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const getLocalizedAttributes = (attributes, locale)=>{
    if (!attributes || !LocaleUtils.isValidLocale(locale)) {
        console.error(`getLocalizedAttributes missing attributes or invalid locale: ${locale}`);
        return [];
    }
    return attributes.map((attr)=>{
        if (Array.isArray(attr.value)) {
            return _objectSpread({}, attr, {
                value: attr.value.map((val)=>getLocalizedValue(val, locale)
                )
            });
        }
        if (isPlainObject(attr.value)) {
            return _objectSpread({}, attr, {
                value: getLocalizedValue(attr.value, locale)
            });
        }
        return attr;
    });
};

/**
 * getProductAttributesByFacets
 * Find the product attributes that are configured as a facet
 */ const getProductAttributesByFacets = (facets, attributes, locale)=>{
    if (!facets || facets.length === 0 || !attributes || attributes.length === 0 || !locale) {
        console.error(`Something went wrong trying to match product attributes to facets`);
        return [];
    }
    const facetsToFilter = facets.filter((facet)=>facet.attribute.startsWith('filterableAttributes')
    ).map((facet)=>{
        const attribute = facet.isLocalized ? `${facet.attribute}_${locale}` : facet.attribute;
        return {
            attribute,
            id: facet.id,
            type: facet.type || 'optional'
        };
    });
    return attributes.reduce((prev, attribute)=>{
        const facet1 = facetsToFilter.find((facet)=>facet.id === attribute.name
        );
        if (facet1) {
            prev.push({
                id: facet1.attribute,
                value: attribute.value,
                type: facet1.type
            });
        }
        return prev;
    }, []);
};

/**
 * getAlgoliaFilters
 * Returns a subset of the algolia search paramaters.
 * This function returns the `filters` and the `optionalFilters`
 */ const getAlgoliaFilters = (product, facets, activeSku, locale)=>{
    /**
   * Get all the sku's from the product
   * Create a filter string that excludes these skus from the result e.g:
   * `NOT masterVariant.sku:sku1 AND NOT masterVariant.sku:sku2`
   */ const masterVariantSku = {
        id: 'masterVariant.sku',
        value: product.masterVariant.sku
    };
    const variantSkus = product.variants.map((variant)=>({
            id: 'masterVariant.sku',
            value: variant.sku
        })
    );
    const excludedSkus = createAlgoliaFilters([
        masterVariantSku,
        ...variantSkus
    ], AlgoliaFilterOperator.AND_NOT, AlgoliaFilterOperator.NOT);
    /**
   * Retrieve all the attributes from the product
   * The product attributes are checked against the facets,
   * if they exist in the facets, they will be returned.
   */ const variant1 = Helpers.getActiveVariant(product, activeSku);
    const attributes = getProductAttributesByFacets(facets, getLocalizedAttributes(variant1.attributes, locale), locale);
    /**
   *  Create strict filters, if there are no strict filters, use only the skus
   */ const strictAttributes = attributes.filter((attribute)=>attribute.type === 'strict'
    );
    const filters = strictAttributes.length > 0 ? `${createAlgoliaFilters(strictAttributes, AlgoliaFilterOperator.AND)} ${AlgoliaFilterOperator.AND} ${excludedSkus}` : excludedSkus;
    /**
   *  Create optional filters
   */ const optionalAttributes = attributes.filter((attribute)=>attribute.type === 'optional'
    );
    const optionalFilters = createAlgoliaFilters(optionalAttributes);
    return {
        filters,
        optionalFilters
    };
};

const CrossSellProducts = ({ formatProductUrl , algoliaConfig  })=>{
    const { facets  } = algoliaConfig;
    const { activeSku , product: product1 , productType , activeVariant , staticsUrl  } = useProductDetailContext();
    const { currency , locale , getLabel  } = useIntl();
    const { filters , optionalFilters  } = React.useMemo(()=>getAlgoliaFilters(product1, facets, activeSku, locale)
    , [
        product1,
        facets,
        activeSku,
        locale
    ]);
    // QueryParamaters to be sent to Algolia
    const searchOptions = React.useMemo(()=>{
        const ruleContexts = [
            `cs-${productType}`,
            `cs-${activeSku}`,
            `cs-${replaceWhitespace(activeVariant.brand, '_')}`, 
        ];
        if (CommerceToolsApi.isLenses(activeVariant)) {
            ruleContexts.push(`cs-${replaceWhitespace(activeVariant.lensType, '_')}`);
            activeVariant.replacementFrequency && ruleContexts.push(`cs-${replaceWhitespace(activeVariant.replacementFrequency, '_')}`);
        }
        return {
            filters,
            optionalFilters,
            hitsPerPage: 10,
            ruleContexts
        };
    }, [
        filters,
        optionalFilters,
        productType,
        activeSku,
        activeVariant
    ]);
    const { result , isLoading , hasError  } = useAlgoliaSearch(algoliaConfig, searchOptions);
    const isVisible = result.length > 0 && !isLoading && !hasError;
    const showLoader = result.length === 0 && isLoading;
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [
        currency
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, 'cross-sell recommendation pdp', currency));
    }, [
        currency
    ]);
    return showLoader || isVisible ? /*#__PURE__*/ React.createElement("div", {
        className: "cross-sell-products",
        "data-t": "cross-sell-products"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium"
    }, getLabel('products.crossSell.title')), /*#__PURE__*/ React.createElement(ProductBannerView, {
        products: result,
        formatProductUrl: formatProductUrl,
        staticsUrl: staticsUrl,
        isLoading: isLoading,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction
    }))) : null;
};
var CrossSellProducts$1 = withLazyLoading(CrossSellProducts);

export { AlgoliaAnalytics, AlgoliaConfigProvider, AlgoliaSearch, ConnectedProductListing$1 as ConnectedProductListing, CrossSellProducts$1 as CrossSellProducts, SortBy$1 as CustomSortBy, FacetId, FacetsDesktop, FacetsMobile$1 as FacetsMobile, NoResults, PrimaryFacets, ProductSuggestionContainer as ProductSuggestion, QueryAlgoliaProducts, SearchBar$1 as SearchBar, SearchBox$1 as SearchBox, SearchPageHeader, SearchSuggestion, SortBy$1 as SortBy, StoreSuggestion, SuggestionBlock, VirtualFacets, fetchAlgoliaConfig, isFacetHidden, isFacetVisible, isValidAlgoliaSearchConfig, useAlgoliaConfig };
//# sourceMappingURL=index.js.map
